import { Chip } from '@mui/material'

import { NEUTRAL_GREY_500, TILE_TEXT } from '@/common/constants'

import { PolicyGroup, PolicyType } from '../../../../utils/types'

interface ChipColors {
  background: string
  color: string
}

/**
 * A soft tint with dark text for each policy group. Every pair has a contrast ratio above 6:1,
 * so the text passes WCAG AA at the chip's small size.
 */
const GROUP_COLORS: Record<PolicyGroup, ChipColors> = {
  [PolicyGroup.TRIP]: { background: '#E6EFF6', color: '#182F46' },
  [PolicyGroup.PARKING]: { background: '#E7F3F6', color: TILE_TEXT },
  [PolicyGroup.VEHICLE]: { background: '#FFEEEC', color: '#9A3324' },
  [PolicyGroup.NONE]: { background: '#F0F0F0', color: NEUTRAL_GREY_500 },
}

/**
 * The policy type in the new theme's Policies Library table. It is as wide as its text. The old
 * table uses `PolicyTypeTag` instead.
 */
export const PolicyTypeChip = ({ policyType }: { policyType: PolicyType }) => (
  <Chip
    className="policy-type-chip"
    label={policyType.title}
    size="small"
    sx={{
      ...GROUP_COLORS[policyType._group],
      // Match the table's own font. MUI's default is the theme font.
      fontFamily: 'inherit',
      fontSize: 12,
      fontWeight: 600,
    }}
  />
)
